import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_missing_result",
  ref: "missingResultRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_missing_result_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body px-17 py-9" }
const _hoisted_10 = { class: "timeline" }
const _hoisted_11 = { class: "timeline-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_13 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_14 = { class: "symbol-label bg-light" }
const _hoisted_15 = { class: "svg-icon svg-icon-1" }
const _hoisted_16 = { class: "timeline-content mt-n1 overflow-hidden" }
const _hoisted_17 = { class: "pe-3 ps-3" }
const _hoisted_18 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_19 = { class: "d-flex align-items-center fs-6" }
const _hoisted_20 = { class: "fs-7 text-muted" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_23 = { class: "py-5" }
const _hoisted_24 = { class: "w-100 d-flex flex-column gap-4 lh-sm" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_27 = { class: "flex-fill mx-2" }
const _hoisted_28 = { class: "fw-bold fs-5" }
const _hoisted_29 = { class: "fs-6 text-gray-400" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "svg-icon svg-icon-2" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                  _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.t("inspection.missing")), 1)
                ]),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t("inspection.inspectionResult")), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("inspection.plsSelectOption")), 1),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                          ]),
                          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo?.username), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_el_form_item, { prop: "radio" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.result, (item, index) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  class: "w-100 cursor-pointer",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["symbol-label", 
                                    _ctx.getInspectionResultBgStyleMap(
                                      Number(item.value)
                                    )
                                  ])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["svg-icon svg-icon-1", 
                                      _ctx.getInspectionResultSvgStyleMap(
                                        Number(item.value)
                                      )
                                    ])
                                        }, [
                                          _createVNode(_component_inline_svg_icon, {
                                            src: 
                                        _ctx.getInspectionResultSvgMap(
                                          Number(item.value)
                                        )
                                      
                                          }, null, 8, ["src"])
                                        ], 2)
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, _toDisplayString(item.label), 1),
                                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getInspectionResultDescriptionMap(
                                      Number(item.value),
                                      _ctx.t
                                    )), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("span", _hoisted_31, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "result",
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.radio) = $event)),
                                          value: item.value
                                        }, null, 8, _hoisted_32), [
                                          [_vModelRadio, _ctx.formData.radio]
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.formData.radio == '9999')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createVNode(_component_el_form_item, {
                                prop: "qty",
                                label: _ctx.t('inspection.qty')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.formData.qty,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.qty) = $event)),
                                    min: 1,
                                    max: _ctx.props.maxQty
                                  }, null, 8, ["modelValue", "max"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.loading,
                class: "btn btn-lg btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                      _hoisted_39,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_35)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}